module.exports = __webpack_public_path__ + "static/media/quotes.e277b582.svg";